export function nextDisplayOrder(
  items: Array<{ displayOrder?: number | null }>,
  totalItems = items.length,
): number {
  const maxFromItems = items.reduce((max, item) => {
    const value = Number(item.displayOrder);
    if (!Number.isFinite(value)) return max;
    return Math.max(max, value);
  }, 0);
  const counted = Number.isFinite(totalItems) ? Math.max(0, totalItems) : 0;
  return Math.max(maxFromItems, counted) + 1;
}
